import { api } from '@/api/core/api';

const chatInstructionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChatInstructions: builder.query<string, void>({
      query: () => ({
        url: `debug/chat-instructions`,
        method: 'GET',
        headers: {
          'debug-api-key': import.meta.env.VITE_DEBUG_API_KEY || '',
        },
        responseHandler: async (response) => {
          return await response.text();
        },
      }),
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

export const { useLazyGetChatInstructionsQuery } = chatInstructionsApi;
